import { createSlice } from "@reduxjs/toolkit";

const user = localStorage.getItem("user");

const initialState = {
  user: user ? JSON.parse(user) : null,
};

const authSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setCredentials: (state, action) => {
      state.user = action.payload;
      localStorage.setItem("user", JSON.stringify(action.payload));
    },
    clearCredentials: (state) => {
      state.user = null;
      localStorage.removeItem("user");
    },

    updateProfile: (state, action) => {
      // Handles either state.user.user.profilePic (common) or state.user.profilePic (legacy)
      if (state.user?.user) state.user.user.profilePic = action.payload;
      else if (state.user) state.user.profilePic = action.payload;

      try {
        localStorage.setItem("user", JSON.stringify(state.user));
      } catch {
        // ignore storage quota / serialization errors
      }
    },
    updateNames: (state, action) => {
      const firstname = action.payload?.firstname;
      const lastname = action.payload?.lastname;

      if (state.user?.user) {
        if (firstname) state.user.user.firstname = firstname;
        if (lastname) state.user.user.lastname = lastname;
      } else if (state.user) {
        if (firstname) state.user.firstname = firstname;
        if (lastname) state.user.lastname = lastname;
      }

      try {
        localStorage.setItem("user", JSON.stringify(state.user));
      } catch {
        // ignore
      }
    },
  },
});


export const { setCredentials, clearCredentials, updateNames, updateProfile } =
  authSlice.actions;

export default authSlice.reducer